<script setup lang="ts">
import { isLocatable } from '@/models/info.model';
import { UserLabel } from '@/models/label.model';
import { User } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';

defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { us: UsersState }>();

const labels = computed<UserLabel[]>(() => store.state.us.userLabels);
</script>
<template>
  <v-card
    class="mt-4"
    v-if="
      user.id !== -1 &&
      (labels.length || (user.address && isLocatable(user.address)))
    "
  >
    <v-card-title>Information</v-card-title>
    <v-card-text>
      <v-chip
        v-if="user.language"
        color="info"
        class="mr-2"
        :title="`User is using '${user.language.toUpperCase()}' as their app language`"
        >{{ user.language.toUpperCase() }}</v-chip
      >
      <v-chip
        v-if="user.address && isLocatable(user.address)"
        color="info"
        class="mr-2"
        :title="`${user.address.postal_code} ${user.address.city}`"
        >Has address</v-chip
      >
      <v-chip
        v-for="label in labels"
        :key="label.id"
        color="info"
        class="mr-2"
        >{{ label.value }}</v-chip
      >
    </v-card-text>
  </v-card>
</template>
